import request from "@/utils/request";

// 列表(主数据列表)
export function loadBrandListDataApi(data) {
  return request({
    url: "web/brand/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadBrandExportDataApi(data) {
  return request({
    url: "web/brand/exportData",
    method: "post",
    data
  });
}

// 新增修改
export function saveOrUpdateBrandApi(data) {
  return request({
    url: "web/brand/saveOrUpdate",
    method: "post",
    data
  });
}

// 作废
export function removeBrandApi(data) {
  return request({
    url: "web/brand/remove",
    method: "post",
    data
  });
}

// 初始化
export function initBrandApi(data) {
  return request({
    url: "web/brand/initBrand",
    method: "post",
    data
  });
}

// 品牌下拉
export function brandListSelectDataApi(data) {
  return request({
    url: "web/brand/listSelectData",
    method: "post",
    data
  });
}
